module.exports = __webpack_public_path__ + "img/dentist.c8642845.png";